<third-party-embed [content]="content" [minRole]="'CSR1'"></third-party-embed>
<ng-template #content>
  <div class="iframe-container">
    <iframe [src]="getSrc()"> </iframe>
  </div>
</ng-template>
